import React, { useState, useEffect } from "react";
import apiClient from '../utils/apiClient';
import Select from "react-select";
import Swal from 'sweetalert2';
import { SERVER_BASE } from '../config/server';
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle, faMinusCircle, faTrash, faEdit, faCopy, faEllipsisV, faThumbsUp, faCancel, faCircleCheck, faX, faArrowCircleLeft, faUndo } from '@fortawesome/free-solid-svg-icons';
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
const SuggestionDetails = ({ suggestion }) => {
  const fields = [
    { label: "Inventory Name", value: suggestion.inventoryName },
    { label: "Size", value: suggestion.size },
    { label: "Color", value: suggestion.color },
    { label: "Made Of", value: suggestion.madeOf },
    { label: "Grade", value: suggestion.grade },
    { label: "Brand Name", value: suggestion.brandName },
    { label: "Avg Weight", value: suggestion.avgWeight },
    { label: "UOM", value: suggestion.uom },
    { label: "Remarks", value: suggestion.remarks },
  ].filter((f) => f.value && f.value.toString().trim() !== "");

  return (
    <div className="row mt-3">
      <div className="col-md-12">
        <label className="form-label fw-bold">Suggestions</label>
        <div
          className="form-control"
          style={{
            backgroundColor: "#f8f9fa",
            pointerEvents: "none", // disables interaction
            resize: "none",
          }}
        >
          <ul className="mb-0 ps-3">
            {fields.map((f, idx) => (
              <li key={idx}>
                <strong>{f.label}:</strong> {f.value}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};
const ItemMasterForm = () => {
  const [isEdit, setIsEdit] = useState(false);
  const [editItemId, setEditItemId] = useState(null);
  const [editIndex, setEditIndex] = useState(null);
  const [itemGroup, setItemGroup] = useState(null);
  const [type, setType] = useState(null);
  const [itemGroupCode, setItemGroupCode] = useState("");
  const [itemCode, setItemCode] = useState("");
  const [itemName, setItemName] = useState("");
  const [printName, setPrintName] = useState("");
  const [itemDesc, setItemDesc] = useState("");
  const [size, setSize] = useState("");
  const [disableStructureFields, setDisableStructureFields] = useState(false);
  const [make, setMake] = useState("");
  const [color, setColor] = useState("");
  const [avgWeight, setAvgWeight] = useState("");
  const [uom, setUom] = useState(null);
  const [unit, setUnit] = useState("");
  const [concernedDepartments, setConcernedDepartments] = useState([]);
  const [remarks, setRemarks] = useState("");
  const [additionalNames, setAdditionalNames] = useState([""]);
  const [grade, setGrade] = useState("");
  const [brandName, setBrandName] = useState("");
  const [mmsCode, setMmsCode] = useState("");
  const [mmsName, setMmsName] = useState("");
  const [mmsDesc, setMmsDesc] = useState("");
  const [groupItemName, setGroupItemName] = useState('');
  const [selectedItems, setSelectedItems] = useState([]);
  const [itemGroups, setItemGroups] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [items, setItems] = useState([]); // State for table data
  const [approvedItems, setApprovedItems] = useState([]); // State for table data
  const [rejectedItems, setRejectedItems] = useState([]);
  const code = localStorage.getItem("code");
  const email = localStorage.getItem("email");
  const token=localStorage.getItem("token");
  const [formVisible, setFormVisible] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [uoms, setUoms] = useState([]); // UOM data
  const [groupItems, setGroupItems] = useState([]);
  const [typeFilter, setTypeFilter] = useState("All");
  const navigate = useNavigate();
  const location = useLocation();
  const item = location?.state?.item;
  const suggestionData = location?.state?.suggestionData;
  const fromSuggestion = location?.state?.fromSuggestion;
    const [negativeStock, setNegativeStock] = useState(null);
    const [showNegativeStock, setShowNegativeStock] = useState(false);

  useEffect(() => {
    if (item) {
      
      
      handleEdit(item);
    }
  }, [item]);
  // Fetch Inventory Groups
    const fetchItemGroups = async () => {
        try {
        const response = await apiClient.get(SERVER_BASE+"/item-groups", {
            params: { code },
            headers: {
            Authorization: `Bearer ${token}`, // Add the JWT token in the header
            },
        });
        setItemGroups(
            response.data.map((group) => ({
            value: group.groupName,
            label: `${group.groupCode} - ${group.groupName}`,
            type: group.type,
            itemGroupCode: group.groupCode,
            }))
        );
        } catch (error) {
        console.error("Error fetching item groups:", error);
        }
    };
    const fetchGroupItems = async () => {
        try {
        // Retrieve the token from localStorage
        const token = localStorage.getItem('token');
        if (!token) {
            console.error('Unauthorized: No token found.');
            return;
        }
        // Make the request with the Authorization header
        const response = await apiClient.get(SERVER_BASE + '/getGroupItems', {
            headers: {
            Authorization: `Bearer ${token}`, // Include the JWT token in headers
            },
        });
        
        // Update the purposes state
        setGroupItems(response.data);
        } catch (error) {
        console.error('Error fetching groups:', error);
        }
    };
    const fetchUOMs = async() => {
        try {
        const response = await apiClient.get(SERVER_BASE+"/getUoms", {
            params: { code },
            headers: {
            Authorization: `Bearer ${token}`, // Add the JWT token in the header
            },
        });
        setUoms(
            response.data.map((uom) => ({
            value: uom.abbreviation,
            label: `${uom.unit} - ${uom.abbreviation}`,
            unit: uom.unit
            }))
        );
        } catch (error) {
        console.error("Error fetching item groups:", error);
        }
    };
    const fetchDepartments = async () => {
        try {
        const response = await apiClient.get(SERVER_BASE+"/departments", {
            params: { code },
            
            headers: {
                Authorization: `Bearer ${token}`, // Add the JWT token in the header
            },
            
        });
        const departmentsData = response.data;
        setDepartments(
            departmentsData.map((dept) => ({
            value: dept.name,
            label: dept.name,
            }))
        );
        } catch (error) {
        console.error("Error fetching departments:", error);
        }
    };
    const fetchItems = async () => {
    try {
        const response = await apiClient.get(SERVER_BASE + "/get-items", {
        params: { centerCode: code },
        headers: {
            Authorization: `Bearer ${token}`, // Add the JWT token in the header
        },
        });

        const sortedItems = response.data.sort((a, b) => b.id - a.id); // Sort by id DESC
        setItems(sortedItems);
    } catch (error) {
        console.error("Error fetching items:", error);
    }
    };
    const fetchApprovedItems = async () => {
    try {
        const response = await apiClient.get(SERVER_BASE + "/get-items-approved", {
        params: { centerCode: code },
        headers: {
            Authorization: `Bearer ${token}`, // Add the JWT token in the header
        },
        });

        const sortedItems = response.data.sort(
        (a, b) => new Date(b.approvedAt) - new Date(a.approvedAt) // sorts by full datetime
        );
        
        setApprovedItems(sortedItems);
    } catch (error) {
        setApprovedItems([]);
        console.error("Error fetching items:", error);
    }
    };
    const fetchRejectedItems = async () => {
        try {
        const response = await apiClient.get(SERVER_BASE+"/get-items-rejected", {
            params: { centerCode:code },
            headers: {
            Authorization: `Bearer ${token}`, // Add the JWT token in the header
            },
        });
        const sortedItems = response.data.sort(
        (a, b) => new Date(b.approvedAt) - new Date(a.approvedAt) // sorts by full datetime
        );
        setRejectedItems(sortedItems);
        
        } catch (error) {
        setRejectedItems([])
        console.error("Error fetching items:", error);
        }
    };

  const toggleFormVisibility = () => {
    setFormVisible(!formVisible);
    setShowForm(false)
    resetForm();
    resetGroupForm();
  };
  const toggleGroupFormVisibility = () => {
    setFormVisible(false);
    setShowForm(!showForm)
    resetForm();
    resetGroupForm();
  };
  const resetGroupForm = () => {
    setGroupItemName('');
    setSelectedItems([]);
  };
  const resetForm = () => {
    setItemGroup(null);
    setType(null);
    setItemGroupCode("");
    setItemName("");
    setItemDesc("");
    setSize("");
    setMake("");
    setColor("");
    setAvgWeight("");
    setUom(null);
    setUnit("");
    setGrade("");
    setConcernedDepartments([]);
    setRemarks("");
    setAdditionalNames([""]);
    setPrintName("");
  };
  useEffect(() => {
    const baseParts = [itemName, size, color].filter(Boolean);
    const baseName = baseParts.join(" ");

    const additionalDetails = [make, grade].filter(Boolean).join(" ");
    const fullAdditional = [additionalDetails, brandName].filter(Boolean).join(" - ");

    const newPrintName = fullAdditional
      ? `${baseName} - ${fullAdditional}`
      : baseName;

    setPrintName(newPrintName.toUpperCase());
  }, [itemName, color, size, make, grade, brandName]);

  const handleChange = (setter) => (event) => {
    setter(event.target.value);
  };
  const handleInputChange = (setter) => (e) => {
    setter(e.target.value);
  };
  const handleItemsChange = (selectedOptions) => {
    setSelectedItems(selectedOptions || []);
  };

  const handleSelectChange = (selectedOption, { name }) => {
    if (name === "itemGroup") {
      setItemGroup(selectedOption)
      setItemGroupCode(selectedOption?.itemGroupCode || "")
      const shouldShow =
      selectedOption?.itemGroupCode == "B" || selectedOption?.id == 7;

    setShowNegativeStock(shouldShow);
      if (shouldShow && !negativeStock) {
        setNegativeStock({
          value: 0,
          label: "No",
        });
      }
      
      if (!shouldShow) {
        setNegativeStock(null);
      }
    }
    if (name === "uom") {
      setUom(selectedOption)
      setUnit(selectedOption?.unit || "")
    }
    if (name === "type") {
      setType(selectedOption)
      if (selectedOption.value == "Constructed Structure") {
        setSize("");
        setColor("");
        setGrade("");
        setMake("");
        setBrandName("");
        setAvgWeight("");
        setDisableStructureFields(true);
      } else {
        setDisableStructureFields(false);
      }
    }
    if (name == "negativeStock") {
      setNegativeStock(selectedOption);
    }
  };

  const handleConcernedDeptSelectChange = (selectedOptions) => {
    if (selectedOptions.some((option) => option.value === "all")) {
      setConcernedDepartments(departments);
    } else {
      setConcernedDepartments(selectedOptions);
    }
  };
  const getOptions = () => {
    return [{ value: "all", label: "Select All" }, ...departments];
  };

  const handleAdditionalNameChange = (index, value) => {
    const newAdditionalNames = [...additionalNames];
    newAdditionalNames[index] = value;
    setAdditionalNames(newAdditionalNames );
  };

  const handleAddAdditionalName = () => {
    setAdditionalNames([...additionalNames, ""]);
  };

  const handleDeleteAdditionalName = (index) => {
    const newAdditionalNames = [...additionalNames];
    newAdditionalNames.splice(index, 1);
    setAdditionalNames(newAdditionalNames );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Check if all required fields are filled
    if (!itemName) {
      Swal.fire({
        icon: 'warning',
        title: 'Oops...',
        text: 'Pleaser Enter Inventory Name!',
        position: 'top-end',  // Positioning Swal to the right end
        showConfirmButton: false,
        timer: 1500, // Auto close after 1.5 seconds
        toast:true,
      });
      return;
    }
    if (!itemGroup) {
      Swal.fire({
        icon: 'warning',
        title: 'Oops...',
        text: 'Pleaser Select Inventory Group!',
        position: 'top-end',  // Positioning Swal to the right end
        showConfirmButton: false,
        timer: 1500, // Auto close after 1.5 seconds
        toast:true,
      });
      return;
    }
    if (!type) {
      Swal.fire({
        icon: 'warning',
        title: 'Oops...',
        text: 'Pleaser Select Inventory type!',
        position: 'top-end',  // Positioning Swal to the right end
        showConfirmButton: false,
        timer: 1500, // Auto close after 1.5 seconds
        toast:true,
      });
      return;
    }
    if (!concernedDepartments.length) {
      Swal.fire({
        icon: 'warning',
        title: 'Oops...',
        text: 'Pleaser Select at least One Department!',
        position: 'top-end',  // Positioning Swal to the right end
        showConfirmButton: false,
        timer: 1500, // Auto close after 1.5 seconds
        toast:true,
      });
      return;
    }
    if (!uom) {
      Swal.fire({
        icon: 'warning',
        title: 'Oops...',
        text: 'Pleaser Select UOM!',
        position: 'top-end',  // Positioning Swal to the right end
        showConfirmButton: false,
        timer: 1500, // Auto close after 1.5 seconds
        toast:true,
      });
      return;
    }
  
    let submissionData = {
      itemName,
      itemGroup: itemGroup?.value || null,
      itemGroupCode,
      type: type?.value || null,
      itemDesc,
      size,
      make,
      color,
      avgWeight,
      grade,
      printName,
      uom: uom?.value || null,
      unit,
      concernedDepartments: concernedDepartments?.map((d) => d.value) || [],
      additionalNames: additionalNames || [],
      code,
      remarks,
      email,
      negativeStock: negativeStock?.value ?? 0,
    };
  
    try {
      // Attempt to save the item
      if (isEdit) {
        submissionData = {...submissionData, itemCode:itemCode}
        
        // Update API call
        await apiClient.post(`${SERVER_BASE}/editItem/${editItemId}`, submissionData, {headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        }
      });
        Swal.fire({
          icon: 'success',
          title: 'Inventory updated successfully!',
          toast: true,
          position: 'top-end',
          timer: 2000,
          showConfirmButton: false,
        });
        setEditItemId(null);
        setIsEdit(false);
      } else {
        // Create API call
        const response = await apiClient.post(SERVER_BASE+"/save-item", submissionData, {
          headers: {  Authorization: `Bearer ${token}` },
        });
        Swal.fire({
          icon: 'success',
          title:'Created!',
          toast: true,
          position: 'top-end',  // Positioning Swal to the right end
          showConfirmButton: false,
          timer: 1500, // Auto close after 1.5 seconds
        });
      }
      navigate('../itemApproval')
    } catch (error) {
      console.error("Error saving data:", error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response.data.message,
        position: 'top-end',  // Positioning Swal to the right end
        showConfirmButton: false,
        timer: 1500, // Auto close after 1.5 seconds
      });
    }
  };
    const handleSubmitAndApprove = async (e) => {
    e.preventDefault();
    
    // Check if all required fields are filled
    if (!itemName) {
      Swal.fire({
        icon: 'warning',
        title: 'Oops...',
        text: 'Pleaser Enter Inventory Name!',
        position: 'top-end',  // Positioning Swal to the right end
        showConfirmButton: false,
        timer: 1500, // Auto close after 1.5 seconds
        toast:true,
      });
      return;
    }
    if (!itemGroup) {
      Swal.fire({
        icon: 'warning',
        title: 'Oops...',
        text: 'Pleaser Select Inventory Group!',
        position: 'top-end',  // Positioning Swal to the right end
        showConfirmButton: false,
        timer: 1500, // Auto close after 1.5 seconds
        toast:true,
      });
      return;
    }
    if (!type) {
      Swal.fire({
        icon: 'warning',
        title: 'Oops...',
        text: 'Pleaser Select Inventory type!',
        position: 'top-end',  // Positioning Swal to the right end
        showConfirmButton: false,
        timer: 1500, // Auto close after 1.5 seconds
        toast:true,
      });
      return;
    }
    if (!concernedDepartments.length) {
      Swal.fire({
        icon: 'warning',
        title: 'Oops...',
        text: 'Pleaser Select at least One Department!',
        position: 'top-end',  // Positioning Swal to the right end
        showConfirmButton: false,
        timer: 1500, // Auto close after 1.5 seconds
        toast:true,
      });
      return;
    }
    if (!uom) {
      Swal.fire({
        icon: 'warning',
        title: 'Oops...',
        text: 'Pleaser Select UOM!',
        position: 'top-end',  // Positioning Swal to the right end
        showConfirmButton: false,
        timer: 1500, // Auto close after 1.5 seconds
        toast:true,
      });
      return;
    }
  
    let submissionData = {
      itemName,
      itemGroup: itemGroup?.value || null,
      itemGroupCode,
      type: type?.value || null,
      itemDesc,
      size,
      make,
      color,
      avgWeight,
      grade,
      brandName,
      printName,
      uom: uom?.value || null,
      unit,
      concernedDepartments: concernedDepartments?.map((d) => d.value) || [],
      additionalNames: additionalNames || [],
      code,
      email,
      suggestionId:suggestionData?.id,
      fromSuggestion,
      negativeStock: negativeStock?.value ?? 0,
    };
  
    try {
      // Attempt to save the item
      if (isEdit) {
        submissionData = {...submissionData, itemCode:itemCode}
        
        // Update API call
        await apiClient.post(`${SERVER_BASE}/editandApproveItem/${editItemId}`, submissionData, {headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        }
      });
        Swal.fire({
          icon: 'success',
          title: 'Inventory updated and approved successfully!',
          toast: true,
          position: 'top-end',
          timer: 2000,
          showConfirmButton: false,
        });
        setEditItemId(null);
        setIsEdit(false);
      } else {
        // Create API call
        const response = await apiClient.post(SERVER_BASE+"/save-item", submissionData, {
          headers: {  Authorization: `Bearer ${token}` },
        });
        Swal.fire({
          icon: 'success',
          title:'Created!',
          toast: true,
          position: 'top-end',  // Positioning Swal to the right end
          showConfirmButton: false,
          timer: 1500, // Auto close after 1.5 seconds
        });
      }
      navigate('../itemApproval')
    } catch (error) {
      console.error("Error saving data:", error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response.data.message,
        position: 'top-end',  // Positioning Swal to the right end
        showConfirmButton: false,
        timer: 1500, // Auto close after 1.5 seconds
      });
    }
  };

  const handleSubmitGroup = (e) => {
    e.preventDefault();

    if (groupItemName.trim() === '' || selectedItems.length === 0) {
      Swal.fire('Please fill both the required fields', '', 'warning');
      return;
    }

    // Retrieve token from localStorage
    const token = localStorage.getItem('token');
    if (!token) {
      console.error('Unauthorized: No token found.');
      Swal.fire('Unauthorized', 'You need to log in to perform this action.', 'error');
      return;
    }
  
    const itemsNames = selectedItems.map((item) => item.value);

    Swal.fire({
      title: editIndex !== null ? 'Confirm Update' : 'Confirm Create',
      text: editIndex !== null ? 'Are you sure you want to update this group?' : 'Are you sure you want to create this group?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          if (editIndex !== null) {
            await apiClient.put(
              `${SERVER_BASE}/updateGroupItem/${editIndex}`,
              {
              name: groupItemName,
              itemNames: itemsNames,
                code,
              },
              {
                headers: {
                  Authorization: `Bearer ${token}`, // Add the JWT token in the header
                },
              }
            );
            // fetchPurposes();
            setEditIndex(null);
          } else {
            // Create new purpose
            await apiClient.post(
              `${SERVER_BASE}/addGroupItem`,
              {
                name: groupItemName,
                itemNames: itemsNames,
                code,
              },
              {
                headers: {
                  Authorization: `Bearer ${token}`, // Add the JWT token in the header
                },
              }
            );
            // fetchPurposes();
          }

          resetGroupForm();
          Swal.fire(
            editIndex !== null ? 'Updated!' : 'Created!',
            `Group has been ${editIndex !== null ? 'updated' : 'created'}.`,
            'success'
          );
          fetchGroupItems();
        } catch (error) {
          console.error('Error saving group:', error);
          Swal.fire('Error', error.response.data.message, 'error');
        }        
      }
    });
  };

  const handleEdit = (item) => {
    setFormVisible(true);
    setShowForm(false)
    resetGroupForm();
    setIsEdit(true);
    setEditItemId(item.id);
    setItemName(item.itemName)
    setAvgWeight(item.avgWeight)
    setColor(item.color)
    setSize(item.size)
    setMake(item.make)
    setGrade(item.grade)
    setBrandName(item.brandName)
    setPrintName(item.printName)
    setRemarks(item.remarks)
    setItemDesc(item.itemDesc)
    setItemCode(item.itemCode)
    setShowNegativeStock(item.itemGroupCode == "B" || item.itemGroupId == 7);
      // Ensure department and prefix are arrays
      const departmentArray = Array.isArray(item.concernedDepartments)
      ? item.concernedDepartments
      : item.concernedDepartments
      ? item.concernedDepartments?.split(',') // If comma-separated string
      : [];
      
    setConcernedDepartments(departmentArray.map((d) => ({ value: d, label: d })));
    setItemGroup({label:`${item.itemGroupCode} - ${item.itemGroup}`, value:item.itemGroup})
    setType({label:item.type, value:item.type})
    setUom({label:`${item.unit} - ${item.uom}`, value:item.uom});
    setItemGroupCode(item.itemGroupCode);
    setUnit(item.unit);
    const additionalNamesArray = Array.isArray(item.additionalNames)
      ? item.additionalNames
      : item.additionalNames
      ? item.additionalNames?.split(',') // If comma-separated string
      : [""];
    setAdditionalNames(additionalNamesArray.map((name) => name));
    setNegativeStock({
      value: Number(item.negativeStock),
      label: Number(item.negativeStock) === 1 ? "Yes" : "No",
    });
  }; 

  const handleEditGroup = (row) => {
    setGroupItemName(row?.groupItemName); 
    const associatedItems = row?.itemGroups.map((item) => {
      return { value: item.printItemName, label: item.printItemName }; 
    });
    setSelectedItems(associatedItems);
    setEditIndex(row.groupId);
    setShowForm(true);
    setFormVisible(false);
    resetForm();
  };

  const handleClone = (item) => {
    setIsEdit(false)
    setFormVisible(true);
    setShowForm(false)
    resetGroupForm();
    setItemName(item.itemName)
    setAvgWeight(item.avgWeight)
    setColor(item.color)
    setSize(item.size)
    setMake(item.make)
    setGrade(item.grade)
    setPrintName(item.printName)
    setRemarks(item.remarks)
    setItemDesc(item.itemDesc)
    setItemCode(item.itemCode)
      // Ensure department and prefix are arrays
      const departmentArray = Array.isArray(item.concernedDepartments)
      ? item.concernedDepartments
      : item.concernedDepartments
      ? item.concernedDepartments?.split(',') // If comma-separated string
      : [];
      
    setConcernedDepartments(departmentArray.map((d) => ({ value: d, label: d })));
    setItemGroup({label:`${item.itemGroupCode} - ${item.itemGroup}`, value:item.itemGroup})
    setShowNegativeStock(item.itemGroupCode == "B" || item.itemGroupId == 7);
    setType({label:item.type, value:item.type})
    setUom({label:`${item.unit} - ${item.uom}`, value:item.uom});
    setItemGroupCode(item.itemGroupCode);
    setUnit(item.unit);
    const additionalNamesArray = Array.isArray(item.additionalNames)
      ? item.additionalNames
      : item.additionalNames
      ? item.additionalNames?.split(',') // If comma-separated string
      : [""];
    setAdditionalNames(additionalNamesArray.map((name) => name));
    setNegativeStock({
      value: Number(item.negativeStock),
      label: Number(item.negativeStock) === 1 ? "Yes" : "No",
    });
  };

  const handleDelete = async () => {
    const confirmation = await Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to delete this Inventory? This action cannot be undone!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    });
  
    if (confirmation.isConfirmed) {
      try {
        // Send the entire row data to the server
        await apiClient.delete(SERVER_BASE+'/deleteItemMaster', {
          data: {id:item.id, code},
          headers: {
            Authorization: `Bearer ${token}`, // Add the JWT token in the header
          },
        });

        Swal.fire({
          icon: 'success',
          title: 'Inventory deleted successfully!',
          toast: true,
          position: 'top-end',
          timer: 3000,
          showConfirmButton: false,
        });
        navigate('../itemApproval')
      } catch (error) {
        console.error('Error deleting Inventory:', error);
  
        Swal.fire({
          icon: 'error',
          title: 'An error occurred while deleting the Inventory.',
          toast: true,
          position: 'top-end',
          timer: 3000,
          showConfirmButton: false,
        });
      }
    }
  };
  const handleDeleteSuggestion = async () => {
    const confirmation = await Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to delete this suggestion? This action cannot be undone!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    });
  
    if (confirmation.isConfirmed) {
      try {
        // Send the entire row data to the server
        await apiClient.delete(SERVER_BASE+'/deleteSuggestion', {
          data: {id:suggestionData.id},
          headers: {
            Authorization: `Bearer ${token}`, // Add the JWT token in the header
          },
        });

        Swal.fire({
          icon: 'success',
          title: 'Suggestion deleted successfully!',
          toast: true,
          position: 'top-end',
          timer: 3000,
          showConfirmButton: false,
        });
        navigate('../itemApproval')
      } catch (error) {
        console.error('Error deleting suggestion:', error);

      }
    }
  };
  const handleRejectedSuggestion = async () => {
    const confirmation = await Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to reject this suggestion? This action cannot be undone!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, reject it!',
      cancelButtonText: 'Cancel',
    });
  
    if (confirmation.isConfirmed) {
      try {
        // Send the entire row data to the server
        await apiClient.put(SERVER_BASE+'/rejectSuggestion', {
          data: {id:suggestionData.id},
          headers: {
            Authorization: `Bearer ${token}`, // Add the JWT token in the header
          },
        });

        Swal.fire({
          icon: 'success',
          title: 'Suggestion rejected successfully!',
          toast: true,
          position: 'top-end',
          timer: 3000,
          showConfirmButton: false,
        });
        navigate('../itemApproval')
      } catch (error) {
        console.error('Error rejecting suggestion:', error);

      }
    }
  };
  const handleApprove = async (row) => {
    const {id} = row;  // Destructure the necessary fields from row.original
    const confirmation = await Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to approve this Inventory? This action cannot be undone!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, Approve it!',
      cancelButtonText: 'Cancel',
    });
  
    if (confirmation.isConfirmed) {
      try {
        // Send the entire row data to the server
        await apiClient.put(
          `${SERVER_BASE}/approveItemMaster`,
          { id, code, email },
          {
            headers: {
              Authorization: `Bearer ${token}`, // Correct header position
            },
          }
        );

  
        fetchItems();
        fetchApprovedItems();
        Swal.fire({
          icon: 'success',
          title: 'Inventory approved successfully!',
          toast: true,
          position: 'top-end',
          timer: 3000,
          showConfirmButton: false,
        });
      } catch (error) {
        console.error('Error approved Inventory:', error);
  
        Swal.fire({
          icon: 'error',
          title: 'An error occurred while approved the Inventory.',
          toast: true,
          position: 'top-end',
          timer: 3000,
          showConfirmButton: false,
        });
      }
    }
  };
  const handleReject = async () => {
    let selectedValues = []; // keep track of reasons outside didOpen
  
    const { value: formValues } = await Swal.fire({
      title: 'Hold Item',
      html: `
        <div class="container text-start p-2">
          <div class="mb-3">
            <label for="rejectReason" class="form-label fw-bold">Hold Reasons</label>
            <select id="rejectReason" class="form-select">
              <option value="">-- Select Reason --</option>
              <option value="Confirm Inventory Name">Confirm Inventory Name</option>
              <option value="Confirm Dimensions / Capacity / Volume">Confirm Dimensions / Capacity / Volume</option>
              <option value="Confirm Color">Confirm Color</option>
              <option value="Confirm Inventory Material">Confirm Inventory Material</option>
              <option value="Confirm Brand Name">Confirm Brand Name</option>
              <option value="Other">Other</option>
            </select>
            <div id="selectedReasons" class="mt-2 d-flex flex-wrap gap-2"></div>
          </div>
          <div class="mb-3">
            <label for="remarkText" class="form-label fw-bold">Remarks</label>
            <textarea id="remarkText" class="form-control" rows="4" placeholder="Enter your remarks here..."></textarea>
          </div>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: 'Hold',
      cancelButtonText: 'Cancel',
      focusConfirm: false,
      didOpen: () => {
        const select = document.getElementById('rejectReason');
        const container = document.getElementById('selectedReasons');
  
        select.addEventListener('change', () => {
          const value = select.value;
          if (value && !selectedValues.includes(value)) {
            selectedValues.push(value);
  
            // Remove chosen option from dropdown
            const option = select.querySelector(`option[value="${value}"]`);
            if (option) option.remove();
  
            // Create badge
            const badge = document.createElement('span');
            badge.className = "badge bg-primary d-flex align-items-center gap-1 p-2";
            badge.innerHTML = `${value} <span style="cursor:pointer;">&times;</span>`;
  
            // Remove on cross click
            badge.querySelector('span').addEventListener('click', () => {
              selectedValues = selectedValues.filter(v => v !== value);
  
              // Re-add option back to dropdown
              const newOption = document.createElement("option");
              newOption.value = value;
              newOption.textContent = value;
              select.appendChild(newOption);
  
              badge.remove();
            });
  
            container.appendChild(badge);
          }
          select.value = ""; // reset dropdown
        });
      },
      preConfirm: () => {
        const remark = document.getElementById('remarkText').value.trim();
  
        if (selectedValues.length === 0) {
          Swal.showValidationMessage(`Please select at least one Reject Reason`);
          return false;
        }
  
        if (selectedValues.includes("Other") && !remark) {
          Swal.showValidationMessage(`Remarks are required when 'Other' is selected`);
          return false;
        }
  
        return { reasons: selectedValues.join(","), remark };
      }
    });
  
    if (formValues) {
      const { reasons, remark } = formValues;
  
      try {
        await apiClient.put(`${SERVER_BASE}/reject-item`, {
          id: item.id,
          reasons, // comma-separated string
          remark,
          email,
        });
  
        navigate('../itemApproval');
  
        Swal.fire({
          icon: 'success',
          title: 'Inventory moved on hold successfully!',
          toast: true,
          position: 'top-end',
          timer: 3000,
          showConfirmButton: false,
        });
      } catch (error) {
        console.error('Error rejecting Inventory:', error);
        Swal.fire({
          icon: 'error',
          title: 'An error occurred while rejecting the Inventory.',
          toast: true,
          position: 'top-end',
          timer: 3000,
          showConfirmButton: false,
        });
      }
    }
  };


  const handleDeleteGroup = (index) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this purpose!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await apiClient.delete(`${SERVER_BASE}/deleteGroupItem/${index}`, {
              headers: {
                Authorization: `Bearer ${token}`, // Add the JWT token in the header
              },
            data: { code },
             // Include 'code' in the delete request
          });
          fetchGroupItems();
          Swal.fire('Deleted!', 'Your group has been deleted.', 'success');
        } catch (error) {
          console.error('Error deleting group:', error);
          Swal.fire('Error', 'There was an issue deleting the group. Please try again later.', 'error');
        }
      }
    });
  };
  

  useEffect(() => {
    fetchItemGroups();
    fetchDepartments();
    fetchItems(); // Fetch items for the table
    fetchApprovedItems()
    fetchRejectedItems()
    fetchUOMs();
    fetchGroupItems();
  }, []);
  return (
    <div className="container mt-5">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>Inventory Master</h3>
      </div>
        <>
      {formVisible && (<>
        <h4 className="text-center">{printName}</h4>
      <div className="formcontainer"> 
      <form onSubmit={handleSubmit}>
      <div className="row">
          <div className="col-md-6">
            <label>Inventory Group</label>
            <Select
              options={itemGroups}
              name="itemGroup"
              onChange={handleSelectChange}
              value={itemGroup}
            />
          </div>
          {/* <div className="col-md-3">
            <label>Inventory Group Code</label>
            <input
              type="text"
              className="form-control"
              name="itemGroupCode"
              value={itemGroupCode}
              disabled
            />
          </div> */}
          <div className="col-md-3">
            <label>Type</label>
            <Select
              options={[
                { value: "Asset", label: "Asset / Capital Nature" },
                { value: "Consumables", label: "Useable / Consumables" },
                { value: "Fixtures & Fittings", label: "Fixtures & Fittings" },
                { value: "Constructed Structure", label: "Constructed Structure" },
              ]}
              name="type"
              onChange={handleSelectChange}
              value={type}
            />
          </div>
          <div className="col-md-3">
            <label>Print Name</label>
            <input
              type="text"
              className="form-control"
              name="printName"
              value={printName}
              disabled
            />
          </div>
          <div className="col-md-3">
            <label>Inventory Name</label>
            <input
              type="text"
              className="form-control"
              name="itemName"
              value={itemName}
              onChange={handleChange(setItemName)}
            />
          </div>
          <div className="col-md-3">
            <label>Size</label>
            <input
              type="text"
              className="form-control"
              name="size"
              value={size}
              disabled={disableStructureFields}
              onChange={handleChange(setSize)}
            />
          </div>
          <div className="col-md-3">
            <label>Color</label>
            <input
              type="text"
              className="form-control"
              name="color"
              value={color}
              disabled={disableStructureFields}
              onChange={handleChange(setColor)}
            />
          </div>
          <div className="col-md-3">
            <label>Made of (Material)</label>
            <input
              type="text"
              className="form-control"
              name="make"
              value={make}
              disabled={disableStructureFields}
              onChange={handleChange(setMake)}
            />
          </div>
          <div className="col-md-3">
            <label>Grade</label>
            <input
              type="text"
              className="form-control"
              name="grade"
              disabled={disableStructureFields}
              value={grade}
              onChange={handleChange(setGrade)}
            />
          </div>
          <div className="col-md-3">
            <label>Brand Name</label>
            <input
              type="text"
              disabled={disableStructureFields}
              className="form-control"
              name="brandName"
              value={brandName}
              onChange={(e) => setBrandName(e.target.value)}
            />
          </div>
          <div className="col-md-3">
            <label>Avg Weight</label>
            <input
            disabled={disableStructureFields}
              type="text"
              className="form-control"
              name="avgWeight"
              value={avgWeight}
              onChange={(e) => setAvgWeight(e.target.value)}
            />
          </div>
          <div className="col-md-3">
            <label>UOM</label>
            <Select
              options={uoms}
              name="uom"
              onChange={handleSelectChange}
              value={uom}
            />
          </div>
          {showNegativeStock && (
                    <div className="col-md-3">
                      <label>Negative Stock</label>
                      <Select
                   options={[
                    { value: 1, label: "Yes" },
                    { value: 0, label: "No" },
                  ]}
                        name="negativeStock"
                        onChange={handleSelectChange}
                        value={negativeStock}
                        // isDisabled={onlyDept}
                      />
                    </div>
                  )}
          <div className="col-md-6">
            <label>Store Issuer Deptt</label>
            <Select
              isMulti
              options={getOptions()}
              name="concernedDepartments"
              onChange={handleConcernedDeptSelectChange}
              value={concernedDepartments}
            />
          </div>

          <div className="col-md-3">
            <label>Inventory Description</label>
            <input
              type="text"
              className="form-control"
              name="itemDesc"
              value={itemDesc}
              onChange={(e) => setItemDesc(e.target.value)}
            />
          </div>
          <div className="col-md-3">
            <label>Remarks</label>
            <input
              type="text"
              className="form-control"
              name="remarks"
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
            />
          </div>
          </div>

        <div className="mb-3">
          <label>Additional Names</label>
          <div className="d-flex flex-wrap">
            {additionalNames.map((name, index) => (
              <div
                key={index}
                className="me-3 mb-2 d-flex align-items-center"
                style={{ flexShrink: 0 }}
              >
                <input
                  type="text"
                  className="form-control"
                  style={{ width: "210px" }}
                  placeholder={`Name ${index + 1}`}
                  value={name}
                  onChange={(e) =>
                    handleAdditionalNameChange(index, e.target.value)
                  }
                />
                {additionalNames.length > 1 && (
                  <button
                    type="button"
                    className="btn btn-danger ms-2"
                    onClick={() => handleDeleteAdditionalName(index)}
                  >
                    <FontAwesomeIcon icon={faMinusCircle} />
                  </button>
                )}
                {index === additionalNames.length - 1 && (
                  <button
                    type="button"
                    className="btn btn-success   ms-2"
                    onClick={handleAddAdditionalName}
                    >
                   <FontAwesomeIcon icon={faPlusCircle} />
                  </button>
                )}
              </div>
            ))}
          </div>
        </div>
        {fromSuggestion && suggestionData && (
        <SuggestionDetails suggestion={suggestionData} />
      )}
      </form>
      {!fromSuggestion &&
      <div className="d-flex justify-content-between align-items-center gap-2 mt-3 flex-wrap">

        {/* Left-side buttons and info */}
        <div className="d-flex gap-2 flex-wrap">
          <button
            onClick={handleDelete}
            className="btn"
            style={{ backgroundColor: "#f55f84", color: 'white', width: '150px' }}
          >
            Delete <FontAwesomeIcon icon={faTrash} />
          </button>
          <button
            onClick={handleReject}
            className="btn btn-danger"
            style={{ width: '150px' }}
          >
            Hold <FontAwesomeIcon icon={faCancel} />
          </button>
          <input
            type="text"
            className="form-control"
            value={`By ${item?.createdByFirstName} on ${moment(item.createdAt).format('DD-MMM-YYYY')}`}
            disabled
            style={{ width: '270px' }}
          />

          <button
            onClick={() => navigate('../itemApproval')}
            className="btn"
            style={{ backgroundColor: "#ac3545", color: 'white', width: '150px' }}
          >
            Cancel <FontAwesomeIcon icon={faUndo} />
          </button>
        </div>

        {/* Right-side submit buttons */}
        <div className="d-flex gap-5 ms-auto flex-wrap">
          <button
            type="button"
            className="btn btn-success"
            onClick={handleSubmit}
            style={{ width: '150px' }}
          >
            Submit <FontAwesomeIcon icon={faCircleCheck} />
          </button>

          <button
            type="button"
            className="btn btn-success"
            onClick={handleSubmitAndApprove}
            style={{ width: '150px' }}
          >
            Approve <FontAwesomeIcon icon={faThumbsUp} />
          </button>
        </div>

      </div>
      }
{fromSuggestion && (
  <div className="d-flex justify-content-between align-items-center gap-2 mt-3 flex-wrap">
    {/* Left-side buttons and info */}
    <div className="d-flex gap-2 flex-wrap">
      <button
        onClick={handleDeleteSuggestion}
        className="btn btn-danger"
        style={{ width: '150px' }}
      >
        Delete <FontAwesomeIcon icon={faTrash} />
      </button>

      <button
        onClick={handleRejectedSuggestion}
        className="btn btn-danger"
        style={{ width: '150px' }}
      >
        Reject <FontAwesomeIcon icon={faCancel} />
      </button>

      <input
        type="text"
        className="form-control"
        value={`By ${suggestionData?.createdBy} on ${moment(suggestionData?.createdAt).format('DD-MMM-YYYY')}`}
        disabled
        style={{ width: '270px' }}
      />

      <button
        onClick={() => navigate('../itemApproval')}
        className="btn"
        style={{ backgroundColor: "#ac3545", color: 'white', width: '150px' }}
      >
        Cancel <FontAwesomeIcon icon={faUndo} />
      </button>
    </div>

    {/* Right-side Approve button */}
    <div className="d-flex gap-5 ms-auto flex-wrap">
      <button
        type="button"
        className="btn btn-success"
        onClick={handleSubmitAndApprove}
        style={{ width: '150px' }}
      >
        Approve Suggestion <FontAwesomeIcon icon={faThumbsUp} />
      </button>
    </div>
  </div>
)}

      </div>
      </>)}
      </>
    </div>
  );
};

export default ItemMasterForm;
